import React from 'react';
import PropTypes from 'prop-types';
import {COMPONENT_TYPE} from '@learningblocks/exp-constants/lib/Utilities';

export function RenderContents(props) {
  const setComponentId = (componentID) => `${props.tabId}_${componentID}`;

  return props.contents.map(function (content) {
    switch (content.type) {
      case COMPONENT_TYPE.PLAIN_TEXT:
        return React.cloneElement(props.components[COMPONENT_TYPE.PLAIN_TEXT], {
          key: setComponentId(content.id),
          content: content.text,
        });
      case COMPONENT_TYPE.FULL_WIDTH_IMAGE:
        return React.cloneElement(
          props.components[COMPONENT_TYPE.FULL_WIDTH_IMAGE],
          {
            key: setComponentId(content.id),
            image: content.image,
            caption: content.caption,
          }
        );
      case COMPONENT_TYPE.CSCQ:
        return React.cloneElement(props.components[COMPONENT_TYPE.CSCQ], {
          ...content,
          id: setComponentId(content.id),
          key: setComponentId(content.id),
        });
      default:
        return null;
    }
  });
}

RenderContents.propsTypes = {
  /**
   * UniqueId of the tab
   */
  tabId: PropTypes.number,
  /**
   * List of Contents to be rendered
   */
  contents: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * UniquieId for the component
       */
      id: PropTypes.number,
      /**
       * Type of component to be rendered
       */
      type: PropTypes.string,
    })
  ),
  /**
   * React Components to be rendered as Content
   */
  components: PropTypes.object,
};

RenderContents.defaultProps = {};
